import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";

class Emblem2009Form extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    emblemType: 'alone'
                },
                validated: true
            })
        }
    }

    @autobind
    handleSelect(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                emblemType: {
                    $set: item.value
                },
            }
        }))
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin19">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        <TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'나 홀로 블로그', value:'alone' },
                            { label:'2009년 기대주', value:'talent' },
                            { label:'So Cool 블로그', value:'cool' },
                            { label:'친철한 블로그', value:'kind' },
                            { label:'비공식 우수블로그', value:'informal' }
                        ]} selected={data.setting.emblemType} onSelect={this.handleSelect}/>
                        배지를 표시합니다.
                    </div>
                    <div className="item_set item_sub">
                        스킨 치환자는 <span className="txt_em"> [##_Emblem2009_##]</span>
                        입니다.
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

Emblem2009Form.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default Emblem2009Form
